// Data Manager Types
// ✅ NO MAGIC STRINGS: Use enums/constants for all data keys, events, and error messages

export enum DataKey {
  AUTH = "auth",
  ORGANIZATION = "organization",
  PROJECT = "project",
  USER = "user",
  APPLICATION = "application",
}

export enum DataEvent {
  LOAD = "load",
  LOAD_SUCCESS = "load_success",
  LOAD_ERROR = "load_error",
  UPDATE = "update",
  UPDATE_SUCCESS = "update_success",
  UPDATE_ERROR = "update_error",
  INVALIDATE = "invalidate",
}

export enum DataManagerError {
  NOT_FOUND = "not_found",
  VALIDATION_FAILED = "validation_failed",
  LOAD_FAILED = "load_failed",
  UPDATE_FAILED = "update_failed",
}

export interface DataContract<T> {
  validate(data: unknown): data is T;
  transform?(data: unknown): T;
}

export interface DataManagerContract {
  get<T>(key: DataKey): T | undefined;
  set<T>(key: DataKey, value: T): void;
  load<T>(
    key: DataKey,
    loader: () => Promise<T>,
    contract: DataContract<T>,
  ): Promise<T>;
  invalidate(key: DataKey): void;
  on(event: DataEvent, handler: (key: DataKey, data?: unknown) => void): void;
}
